import React from 'react';
import { howItWorks } from '../data/mock';

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="py-20 md:py-32 bg-bg-page">
      <div className="container">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-accent-wash text-accent-text text-sm font-medium mb-4">
            Come Funziona
          </span>
          <h2 className="heading-2 mb-4">
            Tre semplici passi per<br />
            <span className="text-accent-text">risparmiare</span>
          </h2>
          <p className="body-large text-text-secondary">
            Inizia a risparmiare sulle ricariche in meno di un minuto.
          </p>
        </div>

        {/* Steps */}
        <div className="relative max-w-4xl mx-auto">
          {/* Connection Line */}
          <div className="hidden md:block absolute top-24 left-1/6 right-1/6 h-0.5 bg-gradient-to-r from-accent-primary via-accent-strong to-accent-primary opacity-30" />
          
          <div className="grid md:grid-cols-3 gap-8 md:gap-12">
            {howItWorks.map((step, index) => (
              <div key={step.id} className="relative text-center">
                {/* Step Number */}
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#8FEC78] to-[#81DD67] flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#8FEC78]/30">
                  <span className="text-2xl font-bold text-white">{step.step}</span>
                </div>
                
                {/* Content */}
                <h3 className="heading-3 mb-3">{step.title}</h3>
                <p className="body-medium text-text-secondary">{step.description}</p>

                {/* Arrow for mobile */}
                {index < howItWorks.length - 1 && (
                  <div className="md:hidden w-0.5 h-8 bg-accent-primary/30 mx-auto my-4" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
